import { combineReducers } from '@reduxjs/toolkit';

// Import individual slice reducers
import wordsReducer, { WordsState } from './wordsSlice';
import categoriesReducer, { CategoriesState } from './categoriesSlice';
import vocabularyGroupsReducer, { VocabularyGroupsState } from './vocabularyGroupsSlice';
import vocabularySetsReducer, { VocabularySetsState } from './vocabularySetsSlice';
import studySessionsReducer, { StudySessionsState } from './studySessionsSlice';
import groupCollectionsReducer, { GroupCollectionsState } from './groupCollectionsSlice';
import flashcardGroupsReducer, { FlashcardGroupsState } from './flashcardGroupsSlice';
import savedWordsReducer, { SavedWordsState } from './savedWordsSlice';
import minigameReducer, { MinigameState } from './minigameSlice';
import progressReducer, { ProgressState } from './progressSlice';
import sessionIntegrationReducer, { SessionIntegrationState } from './sessionIntegrationSlice';

// Export all actions from individual slices
export * from './wordsSlice';
export * from './categoriesSlice';
export * from './vocabularyGroupsSlice';
export * from './vocabularySetsSlice';
export * from './studySessionsSlice';
export * from './groupCollectionsSlice';
export * from './flashcardGroupsSlice';
export * from './savedWordsSlice';
export * from './minigameSlice';
export * from './progressSlice';
export * from './sessionIntegrationSlice';

// Export state interfaces
export type {
    WordsState,
    CategoriesState,
    VocabularyGroupsState,
    VocabularySetsState,
    StudySessionsState,
    GroupCollectionsState,
    FlashcardGroupsState,
    SavedWordsState,
    MinigameState,
    ProgressState,
    SessionIntegrationState,
};

// Combined vocabulary state interface
export interface VocabularyState {
    words: WordsState;
    categories: CategoriesState;
    vocabularyGroups: VocabularyGroupsState;
    vocabularySets: VocabularySetsState;
    studySessions: StudySessionsState;
    groupCollections: GroupCollectionsState;
    flashcardGroups: FlashcardGroupsState;
    savedWords: SavedWordsState;
    minigame: MinigameState;
    progress: ProgressState;
    sessionIntegration: SessionIntegrationState;
}

// Combine all vocabulary reducers
const vocabularyReducer = combineReducers({
    words: wordsReducer,
    categories: categoriesReducer,
    vocabularyGroups: vocabularyGroupsReducer,
    vocabularySets: vocabularySetsReducer,
    studySessions: studySessionsReducer,
    groupCollections: groupCollectionsReducer,
    flashcardGroups: flashcardGroupsReducer,
    savedWords: savedWordsReducer,
    minigame: minigameReducer,
    progress: progressReducer,
    sessionIntegration: sessionIntegrationReducer,
});

export default vocabularyReducer;
